/* --------------------------------------------------------------------------
	Formstone
-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import { icon } from "./page.js";
	import "formstone/dist/js/core.js";
	import "formstone/dist/js/touch.js";
	import "formstone/dist/js/mediaquery.js";
	import "formstone/dist/js/carousel.js";

	var NextIcon,
	    PrevIcon;

	function initCarousel() {
		PrevIcon = "arrow_left";
		NextIcon = "arrow_right";

		// Random notes:
		// 
		// Add class="js-carousel" and the element's children turn into
		// slides. Little noise in theme code. Terrible for performance
		// since the carousel is built onload causing forced re-layouts.
		//
		// Want to make a carousel (PHP) component that takes the inner HTML and
		// settings and builds the HTML server side.
		//
		// Alternate: Maybe use intersection observer to boot carousels later?
		//
		// Thought this might help, but don't have a carousel CSS file. Also
		// don't know the height in advance which is the main problem anyway.
		//
		// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Containment
		// content-visibility: auto;
		// contain: strict;
		//
		// FormStone has some complicated features, like
		//  - linked carousels
		//  - RTL support
		//  - dynamic everything
		//
		// It looks like we use none of that
		//
		
		var $carousel = $(".js-carousel");
		$carousel.carousel().on("update.carousel", onCarouselUpdate);
		carouselSetup($carousel);
	}

	function carouselSetup($element) {
		$element.each(function() {
			var $previous_button = $(this).find(".fs-carousel-control_previous"),
			    previous_text = $previous_button.text(),
			    $next_button = $(this).find(".fs-carousel-control_next"),
			    next_text = $next_button.text(),
			    $gallery_item = $(this).find(".fs-carousel-item");

			$previous_button.attr("disabled", "")
			                .html("<span class='fs-carousel-control-icon'>" + icon(PrevIcon) + "</span>" +
			                      "<span class='fs-carousel-control-label'>" + previous_text + "</span>");

			$next_button.attr("disabled", "")
			            .html("<span class='fs-carousel-control-icon'>" + icon(NextIcon) + "</span>" +
			                  "<span class='fs-carousel-control-label'>" + next_text + "</span>");

			if ($previous_button.is(".fs-carousel-visible")) {
				$previous_button.removeAttr("disabled");
			}

			if ($next_button.is(".fs-carousel-visible")) {
				$next_button.removeAttr("disabled");
			}

			$gallery_item.find("a, button").attr("tabindex", "-1");

			$(this).find(".fs-carousel-item.fs-carousel-visible a, .fs-carousel-item.fs-carousel-visible button").removeAttr("tabindex");
		});
	}

	function onCarouselUpdate() {
		var $carousel = $(this);

		$carousel.find(".fs-carousel-control").attr("disabled", "");

		$carousel.find(".fs-carousel-item a, .fs-carousel-item button").attr("tabindex", "-1");

		setTimeout(function () {
			$carousel.find(".fs-carousel-control.fs-carousel-visible").removeAttr("disabled");

			$carousel.find(".fs-carousel-item.fs-carousel-visible a, .fs-carousel-item.fs-carousel-visible button").removeAttr("tabindex");
		}, 0);
	}

	$(initCarousel);
